export const genId = (prefix: string = ''): string => {
  // Generate 15 random bytes
  const randomBytes = crypto.getRandomValues(new Uint8Array(15)); // browser
  // For Node.js: const randomBytes = require('crypto').randomBytes(15);

  // Base32 encode (RFC 4648, lowercase, no padding)
  const alphabet = 'abcdefghijklmnopqrstuvwxyz234567';
  let bits = 0;
  let value = 0;
  let output = '';

  for (let i = 0; i < randomBytes.length; i++) {
    value = (value << 8) | randomBytes[i];
    bits += 8;

    while (bits >= 5) {
      output += alphabet[(value >>> (bits - 5)) & 31];
      bits -= 5;
    }
  }

  if (bits > 0) {
    output += alphabet[(value << (5 - bits)) & 31];
  }

  return prefix + output.toLowerCase();
}
